wbApp.directive('wbPercentEdit', ['$timeout',
function ($timeout) {
    return {
        restrict: 'A',
        require: '?ngModel',
        priority: 10000,
        link: function (scope, element, attr, ngModel) {
            var destroyed = false;
            var initialized = false;

            $timeout(function () {
                element.autoNumeric('init',
                    {
                        aSign: ' %',
                        aDec: ',',
                        aSep: ' ',
                        pSign: 's',
                        mDec: '2',
                        vMin: '0.00',
                        vMax: '100.00'
                    });

                initialized = true;
            });

            ngModel.$parsers.unshift(function (viewValue) {
                if (!viewValue) {
                    if (attr.required) {
                        return 0;
                    } else {
                        return null;
                    }
                } else {
                    if (typeof viewValue === 'string' || viewValue instanceof String) {
                        return parseFloat(viewValue.replace(/,/g, '.'));
                    }

                    return viewValue;
                }
            });

            ngModel.$formatters.unshift(function (value) {
                if (!value) {
                    if (attr.required) {
                        return "0";
                    } else {
                        return null;
                    }
                } else {
                    return value + "";
                }
            });

            ngModel.$render = function () {
                if (!destroyed) {

                    if (initialized) {
                        if (attr.required) {
                            element.autoNumeric('set', ngModel.$viewValue || '0');
                        } else {
                            element.autoNumeric('set', ngModel.$viewValue);
                        }                        
                    } else {
                        $timeout(function () {
                            if (attr.required) {
                                element.autoNumeric('set', ngModel.$viewValue || '0');
                            } else {
                                element.autoNumeric('set', ngModel.$viewValue);
                            }
                        });
                    }
                }
            };

            element.on('blur keyup change', function () {
                scope.$evalAsync(read);
            });

            function read() {
                var amt = element.autoNumeric('get');
                ngModel.$setViewValue(amt);
            }

            $(element).on("remove", function () {
                destroyed = true;
                element.autoNumeric("destroy");
            })
        }
    };
}]);